import React, { lazy } from 'react'
// Libraries
import { Col, Container, Navbar, Row, Button, Tab, Tabs } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { AnimatePresence, m } from 'framer-motion'
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { Parallax } from "react-scroll-parallax";
import { Helmet } from "react-helmet";
import { Link as ScrollTo } from "react-scroll"
import { SwiperSlide, Swiper } from 'swiper/react';
import { Keyboard } from "swiper/modules";
import { Autoplay } from "swiper/modules";
import { fadeIn, fadeInLeft, zoomIn } from '../../Functions/GlobalAnimations'

import { useNavigate } from "react-router-dom";

import { IMAGE_PATHS } from '../../Functions/Constant';
import Buttons from '../../Components/Button/Buttons'
const LetGo = ({ headingLines = [], subHeading = "", buttonText = "Let’s Go" }) => {
    const navigate = useNavigate();
  
    const jobcritic_usertype = localStorage.getItem("jobcritic_usertype");
    const handleReviewClick = () => {
      const jwtTokenJobcritic = localStorage.getItem("jwt_token_jobcritic"); // Check user_id in localStorage
      if (jwtTokenJobcritic) {
        if(jobcritic_usertype==2){
          navigate("/verifications"); 
        }else{
          navigate("/profile"); // If logged in, go to review form
        }
      } else {
        if(jobcritic_usertype==2){
          navigate("/business-login"); 
        }else{
          navigate("/login");  // If logged in, go to review form
        }
      }
    };
  
    return (
      <m.section className="pt-0 pb-[8%] px-[10%] xl:px-[3%] md:px-[30px] sm:px-0 xs:px-[3%]" {...fadeIn}>
        <div className="bg-gradient-to-tr from-[#FFBF00] via-[#FFDF80] to-[#FFDF80] rounded-[5px] overflow-hidden pt-[126px] md:pt-[72px]">
          <Container>
            <Row className="justify-center items-center">
              <Col xl={5} lg={{ span: 6, order: 2 }} className="font-medium text-darkgray font-serif pb-[100px] ml-[97px] lg:ml-[0px] md:text-center md:pb-24">
                
                <h4 className="-tracking-[1px] mb-[25px] xs:w-[99%] text-[72px] leading-tight md:text-[47px] sm:text-[47px] ">
                  {headingLines.map((line, index) => (
                    <React.Fragment key={index}>
                      {line}<br />
                    </React.Fragment>
                  ))}
                </h4>
  
                {/* Subheading below h4 */}
                {subHeading && (
                  <h4 className="-tracking-[1px] mb-[25px] xs:w-[99%] text-[44px] leading-tight">
                    {subHeading}
                    </h4>
                )}
  
                <Buttons
                  ariaLabel="button link"
                  href="#"
                  className="font-medium font-serif uppercase btn-expand btow"
                  size="lg"
                  color="#fff"
                  themeColor="#232323"
                  title={buttonText}
                  onClick={handleReviewClick}
                />
              </Col>
  
              <Col xl={{ offset: 1, span: 5 }} lg={{ span: 5, order: 1 }} className="p-[0px] xs:px-[15px]">
                <img src={IMAGE_PATHS.punchline} alt="Start Hiring ,Smart Hiring." className="md:mx-auto" />
              </Col>
            </Row>
          </Container>
        </div>
      </m.section>
    );
  };
  
  export default LetGo;
  